export default "__VITE_ASSET__3P0thBrh__"